import React from "react";
import './Home.css';
import aboutUsSectionImg2 from '../../assets/aboutUsSectionImg2.webp'
import paintIcon from '../../assets/paintIcon.webp'
import plasticIcon from '../../assets/plasticIcon.webp'
import textileIcon from '../../assets/textileIcon.webp'
import chemicalIcon from '../../assets/chemicalIcon.webp'
import foodIcon from '../../assets/foodIcon.webp'
import soapIcon from '../../assets/soapIcon.webp'
import Counter from "../../components/counter/Counter";
import Gettouch from "../../components/getTouch/Gettouch";
import { Link } from "react-router-dom";

const Home = () => {
    return (
        <div className="Home-Main-Container">

            <section>
                <div className="Home-What-Sets-Apart-Container">
                    <h2>Established In 1980</h2>
                    <h1>WHAT SETS US APART</h1>
                    <p>"For almost 45 years, we've built our family business on meaningful partnerships and personalized support. When challenges arise, we collaborate to find smart, effective solutions — and that commitment remains constant."</p>
                </div>
            </section>

            <div className="Home-Main-Container-2">

                <div className="Home-About-Us-Section">
                    <img src={aboutUsSectionImg2} alt="aboutUsSectionImg" className="Home-About-Us-Img" />

                    <div className="Home-About-Us-Content-Container">
                        <h1>
                            ABOUT US
                        </h1>
                        <p>
                            Founded in 1980 by the visionary entrepreneur Mr. Pravin P. Bhayani, Chemi Salt Corporation has grown to become one of the most trusted names in the Salts, Minerals, and Chemicals industry across the South Gujarat region.
                            </p>
                            <p>
                            What started as a humble venture is now a reputed name synonymous with quality, reliability, and value. For over four decades, we’ve proudly served a wide range of industries — from agriculture and pharmaceuticals to construction and manufacturing — offering products that meet the highest standards of performance and purity.
                        </p>
                        <p>
                            Today, under the leadership of Mrs. Rita Pravin Bhayani (Proprietor), and the active involvement of the next generation, Mr. Alpesh Bhayani and Mr. Trupesh Bhayani, the company continues to uphold its founding values while embracing innovation and expanding its reach.

                        </p>
                    </div>
                </div>


                <div className="Home-Industry-Serve-Main-Container">
                    <h1>INDUSTRIES WE SERVE</h1>
                    <div className="Home-Industry-Serve-Grid-Container">
                        <Link to="/industriesWeServe#textile" className="Home-Industry-Card-Container">
                            <img src={textileIcon} alt="textileIcon" className="Home-Industry-Section-Img" />
                            <h3>Textile Industries</h3>
                        </Link>

                        <Link to="/industriesWeServe#food" className="Home-Industry-Card-Container">
                            <img src={foodIcon} alt="foodIcon" className="Home-Industry-Section-Img" />
                            <h3>Food Industries</h3>
                        </Link>

                        <Link to="/industriesWeServe#paint" className="Home-Industry-Card-Container">
                            <img src={paintIcon} alt="paintIcon" className="Home-Industry-Section-Img" />
                            <h3>Paint Industries</h3>
                        </Link>

                        <Link to="/industriesWeServe#plastic" className="Home-Industry-Card-Container">
                            <img src={plasticIcon} alt="plasticIcon" className="Home-Industry-Section-Img" />
                            <h3>Plastic Industries</h3>
                        </Link>

                        <Link to="/industriesWeServe#chemical" className="Home-Industry-Card-Container">
                            <img src={chemicalIcon} alt="chemicalIcon" className="Home-Industry-Section-Img" />
                            <h3>Chemical Industries</h3>
                        </Link>
                        <Link to="/industriesWeServe#soap" className="Home-Industry-Card-Container">
                            <img src={soapIcon} alt="soapIcon" className="Home-Industry-Section-Img" />
                            <h3>Soap Industries</h3>
                        </Link>
                    </div>
                </div>


                <section className="Home-Why-Us-Section">
                    <h1 className="Home-Why-Us-Heading">Why Choose Us</h1>
                    <p className="Home-Why-Us-Description">
                        At <span className="Home-Why-Us-Brand-Name">Chemi-Salt</span>, we blend science with innovation to craft cutting-edge chemical solutions that power industries worldwide.<br/> Our mission is to revolutionize chemical manufacturing through sustainability, precision, and unmatched quality.
                    </p>
                    <div className="Home-Why-Us-Cards-Container">
                        <div className="Home-Why-Us-Card">
                            <h3>🌱 Sustainability</h3>
                            <p>We prioritize eco-friendly solutions that support a cleaner, greener future.</p>
                        </div>
                        <div className="Home-Why-Us-Card">
                            <h3>🔬  Innovation</h3>
                            <p>Driven by research and discovery, we push boundaries in chemical tech.</p>
                        </div>
                        <div className="Home-Why-Us-Card">
                            <h3>🤝 Integrity</h3>
                            <p>We build strong partnerships through trust, transparency, and excellence.</p>
                        </div>
                    </div>
                </section>

                <section className="Home-Counter-Main-Container">
                    <h2 className="Home-Why-Us-Heading">Our Impact in Numbers</h2>
                    <div className="Home-Counter-Row-Align-Container">
                        <div className="Home-Counter-Circle-Container">
                            <h1>Clients</h1>
                            <Counter end={150} />
                        </div>
                        <div className="Home-Counter-Circle-Container">
                            <h1>Products</h1>
                            <Counter end={100} />
                        </div>
                        <div className="Home-Counter-Circle-Container">
                            <h1>Storage Capacity</h1>
                            <Counter end={50} />
                        </div>
                    </div>
                </section>
               
                <Gettouch />
            </div>
        </div>
    );
};

export default Home;
